<mat-card style="border-color: #5775a8;">
	<mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
		<div class="flex flex-row rounded-lg w-full" style="align-items: center;">
			<div class="flex flex-col w-full" style="padding-right: 20px;">
				<h4 style="color:white;">Generate New Correspondence</h4>
			</div>
		</div>
	</mat-card-header>

	<mat-card-content>
		<form [formGroup]="form">
			<div class="flex flex-col w-full">
				<br />
				<div>
					<mat-form-field class="container">
						<mat-label>Correspondence Type</mat-label>
						<mat-select formControlName="correspondenceType" (selectionChange)="checkNew()">
							<mat-option *ngFor="let list of typeList" [value]="list.letterTemplateId">
								{{list.title}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div>
					<mat-form-field class="container">
						<mat-label>Title</mat-label>
						<input matInput formControlName="title" (keyup)="checkNew()" placeholder="Title">
					</mat-form-field>
				</div>
				<br />

				<div class="flex flex-row w-full" *ngIf="saveFlag">
					<kendo-editor [(value)]="letterBody" style="height: 600px;width: 780px;"></kendo-editor>
				</div>
				<br /><br />

				<div class="flex flex-row w-full">
					<div style="padding-right: 20px;" *ngIf="saveFlag">
						<button mat-raised-button (click)="saveCorrespondence()" style="padding-right: 20px; background: #7ABDF3;">
							Save
						</button>
					</div>

					<div style="padding-right: 20px;">
						<button mat-raised-button (click)="return()" style="padding-right: 20px;">
							Return
						</button>
					</div>
				</div>
			</div>
		</form>
	</mat-card-content>

</mat-card>



<!-- 
<div class="row" ng-show="!pageControls.showAddCorrespondenceWindow && !pageControls.correspondenceHistoryDirty">
	<span ng-show="complaintId != null && complaintId > 0">
		<br />
		<a class="btn btn-success" ng-click="pageControls.addCorrespondence()"><span
				class="glyphicon glyphicon-plus"></span> Generate New Correspondence</a>
	</span>
</div>
<div class="row" ng-show="pageControls.showAddCorrespondenceWindow">
	<br />
	<div class="panel panel-info">
		<div class="panel-heading">
			<span>
				<span class="glyphicon glyphicon-plus"></span> Generate New Correspondence
			</span>
		</div>
		<div class="panel-body">
			<div class="container">
				<div class="row">
					<label>Correspondence Type <span class="text-danger">*</span></label>
					<span class="alert-danger" ng-show="pageControls.currentCorrespondenceTypeExists">
						<span class="glyphicon glyphicon-warning-sign"></span> This Correspondence Type already exists for this
						business!
					</span>
					<select ng-model="pageControls.generateCorrespondenceType" ng-options="item.Title for item in LetterTemplates"
						class="form-control" ng-change="pageControls.SetGenerateCorrespondenceValues()"></select>
				</div>
				<div class="row">
					<br />
					<label>Title <span class="text-danger">*</span></label>
					<input type="text" class="form-control" ng-model="pageControls.generateCorrespondenceTitle" />
				</div>
				<div class="row" ng-show="pageControls.generateCorrespondenceTitle.length > 0">
					<br />
					<label>Letter <span class="text-danger">*</span></label>
					<span class="text-warning" ng-show="pageControls.loadingLetterTemplate"><br />Loading Letter
						Template...<br /></span>
					<br />
					<div ng-show="!pageControls.loadingLetterTemplate">
						<textarea class="form-control input-lg" cols="20" id="summernote" name="summernote" placeholder=""
							rows="5"></textarea>
					</div>

				</div>
				<div class="row">
					<br />
					<span>
						<span><a class="btn btn-success" ng-click="pageControls.saveCorrespondence()"
								ng-show="pageControls.generateCorrespondenceTitle.length > 0">Save Letter</a></span>
						<span><a class="btn btn-default" ng-click="pageControls.cancelCorrespondence()">Cancel</a></span>
					</span>
				</div>
			</div>
			<br />
		</div>
	</div>
</div>
 -->